export const PlansDuration = ["3D", "1W", "1M", "2M", "3M", "6M", "1Y"];
